var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardToDoClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8L13.5791 6.66667L12.1574 8M13.7919 7C13.7919 10.3137 10.9283 13 7.39595 13C3.86357 13 1 10.3137 1 7C1 3.68629 3.86357 1 7.39595 1C9.7425 1 11.7939 2.18542 12.9068 3.95273M7.39595 3.66667V7L9.52794 8.33333",
    stroke: "#6987B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardToDoClock);
export default __webpack_public_path__ + "static/media/DashboardToDoClock.d7a893cc581cdfeefbdf5592909089c8.svg";
export { ForwardRef as ReactComponent };